import React from 'react'
import LeftSideBar from '../../../Components/Common/LeftSideBar'
import Footer from '../../../Components/Common/Footer'
import TopBar from '../../../Components/Common/TopBar'
import PageHeader from '../../../Components/Common/PageHeader'
import functions from '../../../utils/functions'
import RightSideBar from '../../../Components/Common/RightSideBar'
import ConfigMenu from '../../../Components/ConfigMenu'
import ajax from '../../../utils/ajax'
// import ActivityLoader from '../../../Components/Common/ActivityLoader'
import TextInput from '../../../Components/Common/TextInput'
import dictionary from '../../../utils/dictionary'
import AlertSuccess from '../../../Components/Common/AlertSuccess'
import AlertError from '../../../Components/Common/AlertError'
import ajaxConfig from '../../../utils/remote/ajaxConfig'

class CreateWrongParkingReason extends React.Component {

    state = {
        userId: functions.sessionGuard(),
        description: '',
        info: ''
    }



    onChangedescription = (event) => {
        this.setState({ description: event.target.value })
    }


    onSave = async (event) => {
        event.preventDefault();
        const { description } = this.state;

        if (description.length > 0) {

            const server_response = await ajaxConfig.createWrongParkingDescription(description);

            if (server_response.status === "OK") {
                this.setState({
                    info: ""
                }, () =>
                    this.setState({
                        info: <AlertSuccess message={server_response.details.message} />
                    }))


            } else {
                this.setState({
                    info: ""
                }, () =>

                    this.setState({
                        info: <AlertError message={server_response.details.message} />
                    }))

            }

        } else {
            this.setState({
                info: <AlertError message={dictionary._requiredescription} />,
                loading: ''
            })
        }


    }

    render() {
        return (
            <div className="page">
                <LeftSideBar />
                <div className="main-content side-content pt-0" onClick={functions.closeSystemDrawer}>
                    <TopBar />
                    <div className="container-fluid">
                        <PageHeader
                            title="New Wrong Parking reason"
                            previousPageTitle="Wrong Parking reasons"
                            back="/config/w.p-description"
                        />

                        <div className="row">
                            <div className="col-xl-9 col-lg-12">
                                <div className="row">

                                    <div className="col-sm-12 col-xl-12 col-lg-12">
                                        <div className="card custom-card">
                                            <div className="card-body">
                                                {this.state.info}
                                                <form method="post" onSubmit={this.onSave}>


                                                    <TextInput
                                                        label="Wrong Parking reason"
                                                        type="text"
                                                        onChange={() => this.onChangedescription}
                                                        value={this.state.description}
                                                    />

                                                    <div className="modal-footer">
                                                        <input className="btn ripple btn-success" type="button" value="Save Wrong Parking reason" onClick={this.onSave} />
                                                    </div>
                                                </form>




                                            </div>
                                        </div>


                                    </div>

                                </div>

                            </div>

                            <ConfigMenu />



                        </div>


                    </div>
                </div>
                <RightSideBar />
                 
            </div>


        );

    }
}

export default CreateWrongParkingReason
